import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import http from '../axios';
export function getKnowledgeFaqListPC(data) {
  return Promise.all([http.request({
    url: '/knowledge/getKnowledgeList',
    method: 'get',
    params: data
  }), http.request({
    url: '/knowledge/getKnowledgeCount',
    method: 'get',
    params: data
  })]);
}
export var getKnowledgeFaqTypePC = function getKnowledgeFaqTypePC() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/knowledge/getKnowledgeTypeList',
    method: 'get',
    params: query
  });
};
export var getKnowledgeFaqDetail = function getKnowledgeFaqDetail() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/knowledge/queryKnowledge',
    method: 'get',
    params: query
  });
};
// 赞或踩
export function knowledgeUpdateClick(data) {
  return http.request({
    url: '/knowledge/click',
    method: 'post',
    data: data
  });
}
export var getIdByQRCode = function getIdByQRCode() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/product/getIdByQRCode',
    method: 'get',
    params: query
  });
};
/**
 * @description 调拨审批
 */
export function postV2SessionUserUpdateLocale(data) {
  return http.post('/session/updateLocale', data);
}
export var getProductGetIdByProductionSn = function getProductGetIdByProductionSn() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/product/getIdByProductionSn',
    method: 'get',
    params: query
  });
};
export var getCustomerProductGetService = function getCustomerProductGetService() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return http.request({
    url: '/customer/product/getService',
    method: 'get',
    params: query
  });
};